module.exports = __webpack_public_path__ + "img/traffic-img2.ee4dac97.jpg";